import { IAuthToken, IFacilityUser } from '../../models/auth';
import resources from '../../resources';
import * as authActions from '../actions/auth';

export interface IAuthState {
  loggedIn: boolean;
  token?: IAuthToken;
  facilityUser?: IFacilityUser;
  redirectUrl: string;
}

const initialState: IAuthState = {
  loggedIn: false,
  token: null,
  facilityUser: null,
  redirectUrl: '/'
};

export default function (state: IAuthState = initialState, action): IAuthState {
  switch (action.type) {
    case authActions.AUTH_TOKEN_LOADING:
      return {
        ...state,
        loggedIn: false,
        token: null,
        facilityUser: null
      };

    case authActions.AUTH_TOKEN_LOAD_FAILED:
      return {
        ...state,
        loggedIn: false,
        token: null,
        facilityUser: null
      };

    case authActions.AUTH_TOKEN_LOAD_SUCCESS:
      resources.setToken(action.accessToken);
      return {
        ...state,
        loggedIn: true,
        token: { ...action.accessToken, client: undefined },
        facilityUser: action.accessToken.data.facilityUser
      };

    case authActions.LOGOUT:
      return {
        ...state,
        loggedIn: false,
        token: null,
        facilityUser: null,
        redirectUrl: action.redirectUrl
      };

    case 'persist/REHYDRATE':
      // Set authorization token if available
      if (
        action &&
        action.payload &&
        action.payload.auth &&
        action.payload.auth.token
      ) {
        resources.setToken(action.payload.auth.token);
      }
  }

  return state;
}
